var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"mx-auto table-striped-even"},[_vm._m(0),_c('tbody',_vm._l((_vm.hits),function(hit){return _c('tr',{key:hit.date},[_c('td',[_vm._v(_vm._s(hit.date))]),_c('td',[_vm._v(_vm._s(hit.visits.toLocaleString()))])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Date")]),_c('th',[_vm._v("Visits")])])])
}]

export { render, staticRenderFns }